<template>
  <div id="truck-maker">
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-text>
          <div class="truck-content">
            <span class="settings">{{ $t("truck_maker.truck_settings") }}</span>
            <div class="new-truck-parameters">
              <div class="text-box left-text first-row">
                <v-text-field
                  v-model="settings.truck_width"
                  type="number"
                  step="100"
                  min="0"
                  :label="$t('truck_maker.width')"
                ></v-text-field>
              </div>
              <div class="text-box right-text first-row">
                <v-text-field
                  v-model="settings.truck_height"
                  type="number"
                  step="10"
                  min="0"
                  :label="$t('truck_maker.height')"
                ></v-text-field>
              </div>
              <div class="text-box left-text second-row">
                <v-text-field
                  v-model="settings.truck_length"
                  type="number"
                  step="10"
                  min="0"
                  :label="$t('truck_maker.length')"
                ></v-text-field>
              </div>
              <div class="text-box right-text second-row">
                <v-text-field
                  v-model="settings.max_weight"
                  type="number"
                  step="10"
                  min="0"
                  :label="$t('truck_maker.max_pallet_weight')"
                ></v-text-field>
              </div>
              <div class="text-box left-text third-row">
                <v-text-field
                  v-model="settings.default_truck_spacing"
                  type="number"
                  step="10"
                  min="0"
                  :label="$t('truck_maker.spacing_between')"
                ></v-text-field>
              </div>
            </div>
            <div class="dialog-buttons">
              <div class="alert" v-if="pallets.length == 0">
                <v-alert :value="true" type="warning">
                  {{ $t("truck_maker.select_pallets") }}
                </v-alert>
              </div>
              <div class="confirm-button">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="green"
                      @click="createTruck()"
                      v-on="on"
                      :disabled="!settingsSet"
                    >
                      <v-icon color="white">done</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("truck_maker.confirm") }}</span>
                </v-tooltip>
              </div>
              <div class="cancel-button">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn color="red" @click="dialog = false" v-on="on">
                      <v-icon color="white">close</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("truck_maker.cancel") }}</span>
                </v-tooltip>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Truck from "@/models/Truck.js";
export default {
  name: "truck-maker",
  props: ["orders", "pallets"],
  data() {
    return {
      settings: {},
      dialog: false,
      user: this.$session.get("user"),
      onKeyUp: e => {
        if (e.key === "Enter") {
          this.saveChanges();
        }
        if (e.key === "Escape") {
          this.dialog = false;
        }
      }
    };
  },
  computed: {
    settingsSet() {
      if (
        this.settings.truck_height == null ||
        this.settings.truck_height == ""
      )
        return false;
      if (
        this.settings.truck_length == null ||
        this.settings.truck_length == ""
      )
        return false;
      if (this.settings.max_weight == null || this.settings.max_weight == "")
        return false;
      if (
        this.settings.default_truck_spacing == null ||
        this.settings.default_truck_spacing == ""
      )
        return false;
      if (this.settings.truck_width == null || this.settings.truck_width == "")
        return false;
      const unloadedPallets = this.pallets.filter(pallet => {
        return pallet.truck_id == null;
      });
      if (unloadedPallets.length == 0) return false;
      return true;
    }
  },
  created() {
    this.initialize();
  },
  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else{
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    }
  },
  methods: {
    initialize() {
      let packingTypeId = 0;
      const order = Object.create(this.orders[0]); // get first order
      //try to get from customer
      if (this.user.company.pref_packing_type) {
        packingTypeId = this.user.company.pref_packing_type;
      }
      // if failed to find, get prefered from company
      if (order.customer != null) {
        if (order.customer.pref_packing_type) {
          packingTypeId = order.customer.pref_packing_type;
        }
      }
      //if not found exit
      if (!packingTypeId) {
        return;
      }
      const found = this.user.company.packing_types.find(e => {
        return e.id === packingTypeId;
      });
      //if found set settings to this
      if (found) {
        this.settings = found;
      }
    },
    open() {
      this.dialog = true;
    },
    async createTruck() {
      this.$store.commit('setLoading', true);
      await Truck.generate(this.pallets, this.settings);
      this.$emit("newTruck");
      this.$store.commit('setLoading', false);
      this.dialog = false;
    },

    saveChanges() {
      if(!this.dialog || !this.settingsSet) return;
      this.createTruck();
    }
  }
};
</script>

<style scoped>
.truck-content {
  width: 100%;
  height: 100%;
  min-height: 300px;
  position: relative;
}
.new-truck-parameters {
  position: relative;
  height: 50px;
}
.dialog-buttons {
  position: relative;
  height: 300px;
}
.text-box {
  width: calc(50% - 20px);
  position: absolute;
  z-index: 10;
}
.left-text {
  left: 0;
}
.right-text {
  right: 0;
}
.first-row {
  top: 0px;
}
.second-row {
  top: 60px;
}
.third-row {
  top: 120px;
}
.alert {
  position: absolute;
  top: 150px;
  width: 100%;
  height: 90px;
}
</style>
